// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-component--bordered .password-card {
  border: 1px solid #e5e6e6;
}

.login__header {
    display: flex;
    flex-direction: column;
    gap: calc(.5rem);
    align-items: center;
    max-width: 400px;
    margin: 0 auto calc(1.5rem) auto;
    text-align: center;
  }

.login__header h1 {
      margin-bottom: 0;
    }

.login__sign-up-container {
    margin: calc(1.5rem) 0;
    text-align: center;
  }

.login__instructions {
    margin: 0 0 1rem;
    text-align: center;
  }

.login .notification {
    margin-bottom: calc(2rem);
  }

@media (width > 640px) {

.login .notification {
      margin-bottom: calc(3rem)
  }
    }

.login__shared-audio-notification {
    margin-bottom: calc(2rem);
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
